"use client";

import ProductHero from "./ProductHero";
import ProductGrid from "./ProductGrid";
import type { UnifiedProduct } from "@/lib/product-data/product.types";

type Props = {
  title: string;
  subtitle?: string;
  description?: string;
  products: UnifiedProduct[];
  basePath: string; // e.g. '/products/mobile'
  accentBgClass?: string;
};

export default function ProductListingPage({
  title,
  subtitle,
  description,
  products,
  basePath,
  accentBgClass,
}: Props) {
  return (
    <main className="font-sans text-midnight_text dark:text-white bg-white dark:bg-darkmode min-h-screen transition-colors duration-300">
      <ProductHero
        title={title}
        subtitle={subtitle}
        description={description}
        accentBgClass={accentBgClass}
      />
      <ProductGrid products={products} basePath={basePath} />
    </main>
  );
}
